import type {
  Lead,
  ListModality,
  WorkspaceList,
  WorkspaceListCompanyMember,
  WorkspaceListInput,
  WorkspaceListMember,
  Account,
} from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export type ListDetailResponse = {
  list: WorkspaceList;
  peopleMembers: Array<WorkspaceListMember & { lead?: Lead }>;
  companyMembers: Array<
    WorkspaceListCompanyMember & { company?: Account }
  >;
};

export function listWorkspaceLists(params?: {
  modality?: ListModality;
}): Promise<{ lists: WorkspaceList[] }> {
  return apiGet("/api/lists", params?.modality ? { modality: params.modality } : undefined);
}

export function createWorkspaceList(
  input: WorkspaceListInput,
): Promise<WorkspaceList> {
  return apiPost("/api/lists", input);
}

export function getWorkspaceList(listId: string): Promise<ListDetailResponse> {
  return apiGet(`/api/lists/${listId}`);
}

export function updateWorkspaceList(
  listId: string,
  input: { name?: string; description?: string },
): Promise<WorkspaceList> {
  return apiPatch(`/api/lists/${listId}`, input);
}

export function deleteWorkspaceList(listId: string): Promise<void> {
  return apiDelete(`/api/lists/${listId}`);
}

export function addListMembers(
  listId: string,
  body: {
    leadIds?: string[];
    accountIds?: string[];
    companies?: Array<{ accountId: string; apolloOrgId?: string }>;
  },
): Promise<{ added: number }> {
  return apiPost(`/api/lists/${listId}/members`, body);
}

export function removeListMembers(
  listId: string,
  body: { leadIds?: string[]; accountIds?: string[] },
): Promise<{ ok: boolean }> {
  return apiDelete(`/api/lists/${listId}/members`, body);
}
